import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  statusFilter,
  setStatusFilter,
  onboardingFilter,
  setOnboardingFilter,
  leasingFilter,
  setLeasingFilter,
  apidata,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="statusFilter">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="fromDateFilter">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={onboardingFilter}
              onChange={(e) => setOnboardingFilter(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="leasingFilter">
            <Form.Label>Leasing Partner</Form.Label>
            <Form.Control
              as="select"
              value={leasingFilter}
              onChange={(e) => setLeasingFilter(e.target.value)}
            >
              <option value="">All Partners</option>

              {apidata &&
                Array.from(new Set(apidata.map((item) => item.leasing_partner)))
                  .filter(Boolean)
                  .map((type, index) => (
                    <option key={index} value={type}>
                      {type}
                    </option>
                  ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
